<template>
  <div>
    <q-form ref="editForm">
      <!-- 안전점검일지 기본정보 -->
      <c-card title="LBL0002207" class="cardClassDetailForm">
        <template slot="card-button">
          <q-btn-group outline >
            <!-- [S]결재관련 버튼 -->
            <!-- sysApprovalRequestId: 상세조회시 관련 결재요청일련번호 확인 -->
            <!-- popupParam.isApprContent: 결재요청/결재처리 팝업의 component에 해당 페이지 호출시 true -->
            <!-- approvalStatusCd: 결재요청건에 대한 상태코드 -->
            <!-- popupParam.approvalDocType: TODO(결재할문서에서 상세페이지호출시) -->
            <c-appr-btn 
              ref="appr-btn"
              name="equipment-daily-appr-btn"
              :editable="editable"
              :approvalInfo="approvalInfo"
              @beforeApprAction="saveDataAppr"
              @callbackApprAction="approvalCallback"
              @requestAfterAction="getDetail"
            />
            <!-- 삭제 -->
            <c-btn 
              v-if="editable && !disabled && isOld" 
              label="LBLREMOVE" 
              icon="delete_forever" 
              @btnClicked="removeData" />
            <!-- 저장 -->
            <c-btn
              v-if="editable && !disabled && !safetyCheck.sysApprovalRequestId"
              :url="saveUrl"
              :isSubmit="isSave"
              :param="safetyCheck"
              :mappingType="mappingType"
              label="LBLSAVE"
              icon="save"
              @beforeAction="saveData"
              @btnCallback="saveCallback" />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
            <c-plant
              required
              :disabled="disabled || isOld"
              :editable="editable"
              type="none"
              name="plantCd"
              v-model="safetyCheck.plantCd"
              @datachange="datachange('A')">
            </c-plant>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
            <!-- 점검년월 -->
            <c-datepicker
              required
              :disabled="disabled"
              :editable="editable"
              label="LBL0002200"
              type="month"
              name="checkDate"
              v-model="safetyCheck.checkDate"
              @datachange="datachange('B')">
            </c-datepicker>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
            <!-- 점검부서 -->
            <c-dept
              :disabled="disabled"
              :editable="editable"
              label="LBL0002201"
              name="checkDeptCd"
              v-model="safetyCheck.checkDeptCd"
              @setDeptName="setDeptName">
            </c-dept>
          </div>
          <!-- <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-text
              :disabled="disabled"
              :editable="editable"
              label="점검부서(입력란)"
              name="checkUserId"
              v-model="safetyCheck.checkUserId">
            </c-text>
          </div> -->
        </template>
      </c-card>
      <c-tab
        type="tabcard"
        :tabItems.sync="tabItems"
        :inlineLabel="true"
        v-model="tab"
        align="left"
        @tabClick="tabClick"
      >
        <template v-slot:default="tab">
          <component
            :is="tab.component"
            :safetyCheck="safetyCheck"
            :grid.sync="grid"
            :imprTabInfo.sync="imprTabInfo"
            :contentHeight="contentHeight"
            :disabled="disabled"
            @getDetail="getDetail"
            @setKey="setKey"
          />
        </template>
      </c-tab>
      <c-dialog :param="popupOptions"></c-dialog>
    </q-form>
  </div>
</template>

<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'safetyCheckDetail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        safetyCheckId: '',
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      grid: {
        columns: [],
        height: 'auto',
      },
      safetyCheck: {
        safetyCheckId: '',  // 열화점검 일련 번호
        plantCd: '',  // 사업장 코드
        checkStatusCd: '',  // 계획수립/점검중/점검완료
        checkDeptCd: '',  // 점검부서
        checkUserId: '',  // 점검자 ID
        checkDate: '',  // 점검월
        safetyCheckName: '',  // 점검명
        evaluationCompleteFlag: 'N',  // 결재완료 후 평가완료 처리
        approvalStatusCd: '', // 결재관련 결재상태
        sysApprovalRequestId: '', // 결재관련 결재요청코드
        safetyCheckResultModelList: [], // sheet
        safetyCheckImproveModelList: [], // 개선 list
      },
      editable: true,
      saveUrl: '',
      deleteUrl: '',
      isSave: false,
      isApproval: false,
      mappingType: 'POST',
      detailUrl: '',
      resultItemUrl: '',
      lunarList: '',
      currentMonth: '',
      lunarHolidays: [],
      today: '',
      tab: 'safetyCheckResult',
      tabItems: [
        // 안전점검일지 결과
        { name: 'safetyCheckResult', icon: 'list', label: 'LBL0002208', component: () => import(`${'./safetyCheckResult.vue'}`) },
        // 개선관리
        { name: 'safetyCheckImpr', icon: 'construction', label: 'LBL0000331', component: () => import(`${'@/pages/common/ibm/imprTab.vue'}`) },
      ],
      research: {
        impr: '',
        item: '',
      },
      popupOptions: {
        isFull: true,
        // width: '80%',
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    approvalInfo() {
      return {
        sysApprovalRequestId: this.safetyCheck.sysApprovalRequestId, // 결재요청번호
        /**
         * 결재상태코드
         * ASC0000001	결재중
         * ASC0000002	반려
         * ASC9999999	결재완료
         */
        approvalStatusCd: this.safetyCheck.approvalStatusCd, 
        apprEditable: this.safetyCheck.checkStatusCd && this.safetyCheck.checkStatusCd !== 'MCSC000015', // 결재버튼 활성화 기준
        param: this.safetyCheck, // 결재 param
        approvalUrl: this.updateUrl, // 결재 url
        isApproval: this.isApproval, // 결재 submit
        approvalTypeCd: 'APTC000008', // 결재유형코드
        approvalParamValue: { // 결재상세화면 파라미터
          safetyCheckId: this.safetyCheck.safetyCheckId,
          isApprContent: true
        },
        approvalRequestName: '안전점검 [' + this.safetyCheck.safetyCheckName + ']', // 결재요청명 (문서 title)
        approvalConnId: this.popupParam.safetyCheckId, // 결재연결용 업무일련번호 (문서 key)
      }
    },
    isOld() {
      return Boolean(this.popupParam.safetyCheckId);
    },
    disabled() {
      return this.safetyCheck.checkStatusCd === 'MCSC000015'
        || this.safetyCheck.approvalStatusCd === 'ASC0000001'
    },
    imprTabInfo() {
      return {
        key: this.popupParam.safetyCheckId, // 
        ibmTaskTypeCd: 'ITT0000075',
        ibmTaskUnderTypeCd: 'ITTU000125',
        requestContents: this.safetyCheck.safetyCheckName,
        disabled: this.disabled,
        isOld: this.isOld,
        gridItem: {
          listUrl: selectConfig.sop.safetycheck.improve.get.url,
          param: {
            safetyCheckId: this.popupParam.safetyCheckId,
            imprFlag: true,
          },
          title: 'LBL0002209', // 점검항목별 개선목록
          merge: [
            { index: 0, colName: 'safetyCheckResultId' },
            { index: 1, colName: 'safetyCheckResultId' },
          ],
          columns: [
            {
              name: 'checkItemName',
              field: 'checkItemName',
              // 점검항목
              label: 'LBL0002210',
              align: 'left',
              style: 'width:30%',
              sortable: false,
              fix: true,
            },
            {
              name: 'checkItemCycleName',
              field: 'checkItemCycleName',
              // 주기
              label: 'LBL0002211',
              align: 'center',
              style: 'width:10%',
              sortable: false,
              fix: true,
            },
            {
              name: 'dayStr',
              field: 'dayStr',
              label: '일(주/야)',
              align: 'center',
              style: 'width:10%',
              sortable: false,
              fix: true,
            },
          ],
          research: this.research,
        },
        gridOther: {
          title: 'LBL0001424', // 항목외 개선 목록
        },
      }
    }
  },
  watch: {
    contentHeight() {
      let height = (this.contentHeight - 240);
      if (height < 400) {
        height = 500;
      }
      this.grid.height = height + 'px'
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.sop.safetycheck.plan.get.url;
      this.saveUrl = transactionConfig.sop.safetycheck.plan.insert.url;
      this.deleteUrl = transactionConfig.sop.safetycheck.plan.delete.url;
      this.resultItemUrl = selectConfig.sop.safetycheck.result.newItem.url;
      this.lunarList = selectConfig.sop.min.equipment.result.lunar.url; // 음력 공휴일구하기
      // code setting
      this.today = this.$comm.getToday().slice(-2, this.$comm.getToday().length);
      this.currentMonth = this.$comm.getToday().slice(-5, this.$comm.getToday().length -3);
      if (this.today.substring(this.today, 0) === '0') {
        this.today = this.today.substring(this.today, 0)
      }
      // list setting
      this.getDetail()
    },
    getDetail() {
      if (this.popupParam.safetyCheckId) {
        this.$http.url = this.$format(this.detailUrl, this.popupParam.safetyCheckId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.$_.extend(this.safetyCheck, _result.data);
          this.setColumns();
        },);
      } else {
        this.datachange('A');
      }
    },
    setKey(data) {
      this.popupParam.safetyCheckId = data
      this.getDetail();
    },
    datachange(type) {
      if (type === 'A' && this.safetyCheck.plantCd) {
        /**
         * 사업장에 따라 점검항목을 변경
         * 
         * 사업장은 `선택`이 될 수 없게 처리
         */
        this.$http.url = this.resultItemUrl;
        this.$http.type = 'GET';
        this.$http.param = {
          plantCd: this.safetyCheck.plantCd
        };
        this.$http.request((_result) => {
          this.safetyCheck.safetyCheckResultModelList = _result.data;
          this.$_.forEach(this.safetyCheck.safetyCheckResultModelList, _item => {
            _item.safetyCheckResultId = uid()
          })
          this.setColumns();
        },);
      } else if (type === 'B' && this.safetyCheck.checkDate) {
        // this.grid.data = [];
        this.setColumns();
      }
    },
    setColumns() {
      if (!this.safetyCheck.checkDate) return;

      let _columns = [
        {
          name: 'checkItemName',
          field: 'checkItemName',
          // 점검항목
          label: 'LBL0002210',
          align: 'left',
          style: 'width:450px',
          sortable: false,
          fix: true,
        },
        {
          name: 'checkItemCycleName',
          field: 'checkItemCycleName',
          // 주기
          label: 'LBL0002211',
          align: 'center',
          style: 'width:90px',
          sortable: false,
          fix: true,
        },
      ]
      let year = this.safetyCheck.checkDate.substring(0, 4);
      let month = this.safetyCheck.checkDate.substring(5);

      // 주말 계산
      let date = new Date(Number(year), Number(month), 0);
      let week = ['일', '월', '화', '수', '목', '금', '토'];

      // 양력 공휴일 계산
      let solorHolidays = [ "01-01", "03-01", "05-05", "06-06", "07-17", "08-15", "10-03", "12-25"]; 

      let days = [];
      let parent = [];
      this.$http.url = this.$format(this.lunarList, year);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        // 음력 공휴일 계산은 백엔드에서
        this.lunarHolidays = _result.data

        for (let i = 1; i <= date.getDate(); i++) {
          let dayOfWeek = week[new Date(Number(year) + '-' + Number(month) + '-' + i).getDay()];

          let solarIdx = 0;
          let countDay = 0;
          if (i < 10) {
            countDay = '0' + i
            solarIdx = solorHolidays.indexOf(month + '-0' + i);
          } else {
            countDay = i
            solarIdx = solorHolidays.indexOf(month + '-' + i);
          }
          var lunarIdx = 0;
          if (i < 10) {
            lunarIdx = this.lunarHolidays.indexOf(year + month + '0' + i);
          } else {
            lunarIdx = this.lunarHolidays.indexOf(year + month + i);
          }
          
          var day = '';
          if (dayOfWeek === '일' || dayOfWeek === '토' || solarIdx >= 0 || lunarIdx >= 0) {
            day = 'weekend'
          } else {
            day = 'weekday'
          }
          days.push({
            name: 'day' + i + 'Name',
            field: 'day' + i + 'Name',
            key: 'day' + i,
            day: i,
            // 주
            label: this.$comm.getLangLabel('LBL0002220'),
            currentDay: String(countDay) === String(this.today) && String(month) === String(this.currentMonth) 
                      ? true : false, 
            align: 'center',
            size: 'xs',
            setHeader: true,
            style: 'width:35px',
            // dayType: day,
            headerColor: day === 'weekend' ? '#FFCDD2' : '',
            type: 'custom',
            headType: 'link',
            sortable: false,
            // component: () => import(`${'./equipmentDeteriorResultProxy.vue'}`)
          })
          days.push({
            name: 'nday' + i + 'Name',
            field: 'nday' + i + 'Name',
            key: 'nday' + i,
            day: i,
            // 야
            label: this.$comm.getLangLabel('LBL0002221'),
            currentDay: String(countDay) === String(this.today) && String(month) === String(this.currentMonth) 
                      ? true : false, 
            align: 'center',
            size: 'xs',
            setHeader: true,
            style: 'width:35px',
            // dayType: day,
            headerColor: day === 'weekend' ? '#FFCDD2' : '',
            type: 'custom',
            headType: 'link',
            sortable: false,
            // component: () => import(`${'./equipmentDeteriorResultProxy.vue'}`)
          })
          parent.push({
            headerColor: day === 'weekend' ? '#FFCDD2' : '',
            name: String(i),
            field: String(i),
            label: String(i),
            child: days,
          })
          days = [];
        }
        this.grid.columns = this.$_.concat(_columns, parent);
        // this.grid.data = this.$_.clone(this.safetyCheck.safetyCheckResultModelList)
      },);

      this.safetyCheck.safetyCheckName = year + '년  ' + month + '월  안전관리자 안전점검일지'
    },
    saveData() {
      if (this.isOld) {
        this.saveUrl = transactionConfig.sop.safetycheck.plan.update.url;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = transactionConfig.sop.safetycheck.plan.insert.url;
        this.mappingType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {            
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGSAVE', // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.safetyCheck.regUserId = this.$store.getters.user.userId;
              this.safetyCheck.chgUserId = this.$store.getters.user.userId;

              if (this.mappingType === 'POST') {
                this.$_.forEach(this.safetyCheck.safetyCheckResultModelList, _item => {
                  _item.editFlag = 'C';
                })
              }

              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.safetyCheckId = result.data
      this.getDetail();
    },
    saveDataAppr() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',
        // 결재요청 하기 전 입력된 값을 저장합니다.\n\r 진행하시겠습니까?
        message: 'MSG0000651', 
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.safetyCheck.regUserId = this.$store.getters.user.userId;
          this.safetyCheck.chgUserId = this.$store.getters.user.userId;
          
          this.isApproval = !this.isApproval
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    // [S] 결재관련 
    approvalCallback() { // 결재관련 결재요청버튼 callback
      this.$refs['appr-btn'].apprRequestPop();
    },
    removeData() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',
        message: 'MSGREMOVE', // 삭제하시겠습니까?,
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.safetyCheckId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    /* eslint-disable no-unused-vars */
    setDeptName(deptName) {
      this.safetyCheck.checkDeptName = deptName;
    },
    tabClick() {
       this.$set(this.research, 'impr', uid())
    },
  }
};
</script>
